import React from 'react';
import { Paper, Typography, Box, CircularProgress, useTheme, alpha } from '@mui/material';
import Rating from '@mui/material/Rating';

export function AnalyticsStatCard({ label, value, unit, loading, error, isRating, icon, color }) {
    const theme = useTheme();
    const cardColor = color || theme.palette.primary.main;

    return (
        <Paper elevation={0} sx={{
            p: 3,
            borderRadius: 3,
            border: `1px solid ${theme.palette.divider}`,
            height: '100%',
            minHeight: 140,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            transition: 'box-shadow 0.2s ease, transform 0.2s ease',
            '&:hover': {
                boxShadow: `0 4px 20px ${alpha(cardColor, 0.12)}`,
                transform: 'translateY(-2px)',
            },
        }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
                {icon && (
                    <Box sx={{
                        width: 40,
                        height: 40,
                        borderRadius: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        bgcolor: alpha(cardColor, 0.1),
                        color: cardColor,
                        flexShrink: 0,
                    }}>
                        {icon}
                    </Box>
                )}
                <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600, lineHeight: 1.3 }}>
                    {label}
                </Typography>
            </Box>
            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 40 }}>
                    <CircularProgress size={20} sx={{ color: cardColor }} />
                </Box>
            ) : error ? (
                <Typography color="error" variant="body2">{error}</Typography>
            ) : (
                <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5 }}>
                    <Typography variant="h4" sx={{ fontWeight: 800, color: cardColor, lineHeight: 1 }}>
                        {value != null ? value : '--'}
                    </Typography>
                    {unit && (
                        <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
                            {unit}
                        </Typography>
                    )}
                    {isRating && (
                        <Rating
                            value={Number(value) || 0}
                            precision={0.1}
                            readOnly
                            size="small"
                            sx={{ ml: 1, fontSize: 18 }}
                        />
                    )}
                </Box>
            )}
        </Paper>
    );
}
